import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/Das_Prinzip_von_DDNS_Portweiterleitung_und_P2P_in_einfachen_Worten_erklaert.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>In diesem Video erklären wir Ihnen &quot;hoffentlich&quot; auf verständliche Weise wie DDNS funktioniert, was es ist und wie das Prinzip der Portweiterleitung funktioniert. Zudem zeigen wir auch kurz auf wie P2P funktioniert und aufgebaut ist.</p>
            <p>Folgen Sie uns jetzt im INSTARTV YouTube Kanal, abbonieren Sie uns und erhalten Sie automatisch Informationen sobald neue Videos verfügbar sind damit Sie Ihre INSTAR IP Kamera noch besser nutzen können. Auf <OutboundLink href="https://www.youtube.com/watch?v=FjE95bL7_p4" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)